import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// loaded all file in /src/lang/*.json
const requireLang = require.context('./', true, /\.json$/);

const messages = {};

requireLang.keys().forEach((file) => {
    const lang = file.replace(/(\.\/|\.json$)/g, '');
    messages[lang] = requireLang(file);
});

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: messages,
});

export default i18n;
